import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {MessageImage} from '../../../core/models/message-image.model';

@Component({
  selector: 'cm-image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.scss'],
})
export class ImageCarouselComponent implements OnInit, OnDestroy {
  @Input()
  public images: MessageImage[] = [];

  @Input()
  public interval = 5000; // Default interval of 5 seconds

  public imagePath = '';

  now: number;
  intervalId;

  constructor() { }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  ngOnInit(): void {
    this.intervalId = setInterval(() => this.now = Date.now(), 1000);

    let currentImageIndex = 0;
    this.imagePath = this.images[currentImageIndex].original_url;
    setInterval(() => {
      this.imagePath = this.images[currentImageIndex].original_url;
      console.log(currentImageIndex + ' ' + this.imagePath);
      currentImageIndex++;
      if (currentImageIndex >= this.images.length) {
        currentImageIndex = 0;
      }
    }, this.interval);
  }
}
